import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/**
 * Ambient firefly-like particle background using canvas.
 * Lightweight alternative to tsParticles for the initial build.
 * Renders warm green organic dots that drift slowly.
 */
export function ParticleBackground() {
    const canvasRef = React.useRef(null);
    React.useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const ctx = canvas.getContext("2d");
        if (!ctx)
            return;
        let animationId;
        let particles = [];
        function resize() {
            if (!canvas)
                return;
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }
        function init() {
            resize();
            const count = Math.floor((canvas.width * canvas.height) / 25000);
            particles = Array.from({ length: Math.min(count, 60) }, () => ({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                vx: (Math.random() - 0.5) * 0.3,
                vy: (Math.random() - 0.5) * 0.3,
                r: Math.random() * 2 + 1,
                alpha: Math.random() * 0.3 + 0.05,
                alphaDir: (Math.random() - 0.5) * 0.005,
            }));
        }
        function animate() {
            if (!ctx || !canvas)
                return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (const p of particles) {
                p.x += p.vx;
                p.y += p.vy;
                p.alpha += p.alphaDir;
                if (p.alpha <= 0.03 || p.alpha >= 0.35)
                    p.alphaDir *= -1;
                if (p.x < -10)
                    p.x = canvas.width + 10;
                if (p.x > canvas.width + 10)
                    p.x = -10;
                if (p.y < -10)
                    p.y = canvas.height + 10;
                if (p.y > canvas.height + 10)
                    p.y = -10;
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(124, 179, 66, ${p.alpha})`;
                ctx.fill();
                // Glow
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r * 3, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(124, 179, 66, ${p.alpha * 0.15})`;
                ctx.fill();
            }
            animationId = requestAnimationFrame(animate);
        }
        init();
        animate();
        window.addEventListener("resize", resize);
        return () => {
            cancelAnimationFrame(animationId);
            window.removeEventListener("resize", resize);
        };
    }, []);
    return (_jsx("canvas", { ref: canvasRef, className: "fixed inset-0 pointer-events-none", style: { zIndex: 0 }, "aria-hidden": "true" }));
}
//# sourceMappingURL=ParticleBackground.js.map